import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  DataCollectionApi,
  HiringRequest,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitHiring = createAsyncThunk<
  HiringRequest,
  HiringRequest,
  ThunkApi
>("submitHiring", async (hiringData, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addHiring(hiringData);

    return hiringData;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio datore di lavoro",
      description:
        "Non siamo riusciti a salvare il datore di lavoro.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
